<template lang="pug">
div(class="after-16 matdate")
    div(class="insety-16")
        label(class="bold bond-title fg70") {{ $t('states_territories') }}
    ib-dropdown(class="inset-8 bondsearch-currency outset-0" width="20ch" name="states" v-model="selected" @change="selectState", :data="states")
</template>

<script>
    import mxGb from '../mixin/mixin-global'
    export default {
        name: 'USStates',

        mixins: [ mxGb ],

        data() {
            return {
                selected: '',
                stateLabel: 'All'
            }
        },

        methods: {
            reset() {
                this.selected = '';
                this.stateLabel = 'All';
                this.$emit('stateSelect', this.selected, this.stateLabel);
            },
            selectState() {
                const curState = this.states.filter(state => state.value === this.selected);
                this.stateLabel = curState[0].label;
                this.$emit('stateSelect', this.selected, this.stateLabel);
            }
        },

        mounted() {
            this.$nextTick(() => {
                if (this.subFilters) {
                    this.selected = this.getFilterValue('bondUSStateLike') || '';
                }
                this.selectState();
            });
        }
 }
</script>